var colorClipboard = "";
/** Registers extensions for bootstrap color picker */
export function registerBootstrapColorpickerExtensions() {
    const ExtensionClass = $.colorpicker.Extension;
    $.colorpicker.extensions["extrabuttons"] = class extends ExtensionClass {
        constructor(a, b) {
            super(a, b);
            this.element = null;
        }
        onCreate(e) {
            const colorpicker = this.colorpicker;
            this.element = $("<div class='mt-2 clearfix'>" +
                "<div class='horizontal-button-group d-block float-left fs-16'>" +
                "<div class='ui-button squarer' title='Copy colour'><i class='far fa-copy fa-fw' />&#8203;</div>" +
                "<div class='ui-button squarer' title='Paste colour'><i class='far fa-clipboard fa-fw' />&#8203;</div>" +
                "</div>" +
                "<div class='ui-button squarer d-block float-right fs-16' title='Close'>" +
                "<i class='fas fa-times fa-fw' />&#8203;" +
                "</div>" +
                "</div>");
            colorpicker.picker.append(this.element);
            // Copy.
            this.element.get(0).childNodes[0].childNodes[0].onclick = (e) => {
                colorClipboard = colorpicker.getValue();
            };
            // Paste.
            this.element.get(0).childNodes[0].childNodes[1].onclick = (e) => {
                if (colorClipboard !== "") {
                    colorpicker.setValue(colorClipboard);
                }
            };
            // Close.
            this.element.get(0).childNodes[1].onclick = (e) => {
                // First call to hide does not stick. Have to call it twice.
                colorpicker.hide();
                colorpicker.hide();
            };
        }
        resolveColor() { }
    };
    $.colorpicker.extensions["manualinput"] = class extends ExtensionClass {
        constructor(a, b) {
            super(a, b);
            this.element = null;
        }
        onCreate(e) {
            const colorpicker = this.colorpicker;
            this.element = $("<div class='mt-2'>" +
                "<input type='text' class='ui-input w-100' />" +
                "</div>");
            colorpicker.picker.append(this.element);
            // Input.
            this.inputField = this.element.get(0).childNodes[0];
            this.inputField.value = colorpicker.getValue();
            this.inputField.onchange = (e) => {
                colorpicker.setValue(e.target.value);
            };
        }
        onUpdate() {
            const colorpicker = this.colorpicker;
            if (this.inputField) {
                this.inputField.value = colorpicker.getValue();
            }
        }
    };
}
